<template>
  <v-autocomplete
      :error-messages="error"
      variant="outlined"
      rounded="0"
      :label="translation(translationList.vehicle, 'Vehicul')"
      :items="vehicles"
      item-title="registration_plate"
      name="vehicle"
      item-value="id"
      :loading="loading"
      :disabled="loading"
      v-model="selectedVehicle"
      :clearable="canBeCleared"
      :rules="[v => !!v || translation(translationList.required, 'Acest camp este obligatoriu')]"
      return-object
  >
  </v-autocomplete>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, toRefs, watch } from 'vue';
import { useTranslationStore, translation } from "~/plugins/store/translations";
import type {BasicVehicle} from "~/types/Vehicle";
import type {TranslationList} from "~/types/Utils";

export default defineComponent({
  props: {
    canBeCleared: Boolean,
    modelValue: {
      type: Object as () => BasicVehicle | null,
      default: () => null,
      required: false
    },
    vehicles: {
      type: Array as () => BasicVehicle[],
      default: () => [],
      required: true
    }
  },
  emits: ['update:modelValue', 'validation-vehicle-status'],
  setup(props, { emit }) {
    const { modelValue, vehicles } = toRefs(props);
    const translationStore = useTranslationStore();
    const selectedVehicle = ref(modelValue.value && modelValue.value.registration_plate ? modelValue.value : null);
    const translationList = ref<TranslationList>({});
    const loading = ref(false);
    const error = ref([]);

    onMounted(async () => {
      loading.value = true;
      translationList.value = await translationStore.getTranslations('ro', 'dashboard');

      if (!modelValue.value && vehicles.value.length > 0) {
        selectedVehicle.value = vehicles.value[0];
        emit('update:modelValue', selectedVehicle.value);
      }
      loading.value = false;
      const isValid = !!selectedVehicle.value;
      emit('validation-vehicle-status', { field: 'vehicle', isValid });

      window.addEventListener('validate-vehicle', handleVehicleValidationEvent);
      window.addEventListener('validate-travel', handleVehicleValidationEvent);
    });

    const handleVehicleValidationEvent = (data: any) => {
      if (data.detail && data.detail === 'vehicle') {
        if (!selectedVehicle.value?.registration_plate) {
          error.value.push(translation(translationList.value.required, 'Acest câmp este obligatoriu'));
        } else {
          error.value = [];
          emit('validation-vehicle-status', { field: 'vehicle', isValid: true });
        }
      }
    };

    watch(selectedVehicle, (newValue) => {
      emit('update:modelValue', newValue);
    });

    watch(modelValue, (newValue) => {
      // TODO watch this if it works if not handle; changed to work on travel vehicle select
      // if (newValue && (newValue.id !== selectedVehicle.value?.id)) {
      //   selectedVehicle.value = newValue;
      //   error.value = [];
      // }

      selectedVehicle.value = newValue;
      if (newValue && newValue.registration_plate) {
        error.value = [];
      }

      const isValid = !!newValue;
      emit('validation-vehicle-status', { field: 'vehicle', isValid });
    });

    return {
      selectedVehicle,
      translationList,
      translation,
      loading,
      error,
    };
  },
});
</script>

<style scoped>
</style>